import React from 'react';
import PropTypes from 'prop-types';

import { useCombobox } from './ComboboxContext';

const ComboboxItem = ({ value, label, children, onClick, action }) => {
  const { selectItem, isSelected, highlightedIndex, getItemIndex, multiple } = useCombobox();

  const index = getItemIndex(value);
  const selected = action ? false : isSelected(value);
  const highlighted = action ? false : highlightedIndex === index;

  const classNames = [
    'combobox__item',
    highlighted && 'combobox__item--highlighted',
    selected && 'combobox__item--selected',
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    if (!action) {
      selectItem(value);
    }
    onClick?.();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  if (action) {
    return (
      <li className={classNames} role="presentation">
        <button type="button" className="combobox__item-action" aria-label={label} onClick={handleClick}>
          {children || <span className="combobox__item-label">{label}</span>}
        </button>
      </li>
    );
  }

  return (
    <li
      className={classNames}
      role="option"
      aria-selected={selected}
      aria-label={label}
      onClick={handleClick}
      onKeyDown={handleKeyDown}>
      {children || (
        <>
          {multiple && (
            <input type="checkbox" className="combobox__item-checkbox" checked={selected} readOnly tabIndex={-1} />
          )}
          <span className="combobox__item-label">{label}</span>
        </>
      )}
    </li>
  );
};

ComboboxItem.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  action: PropTypes.bool,
};

ComboboxItem.defaultProps = {
  value: undefined,
  children: null,
  onClick: undefined,
  action: false,
};

export default ComboboxItem;
